// dashboard/components/AllCourses.jsx
import React, { useState } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  TextField,
  InputAdornment,
  Tabs,
  Tab,
  Avatar,
  Rating,
} from '@mui/material';
import { Search, School, Star, People } from '@mui/icons-material';

const AllCourses = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [tabValue, setTabValue] = useState(0);

  const courses = [
    { id: 1, title: 'Biology Course', category: 'Science', rating: 4.8, students: 1234, price: '$49', color: '#4a6cf7' },
    { id: 2, title: 'Contemporary Art', category: 'Art', rating: 4.6, students: 876, price: '$39', color: '#f5a623' },
    { id: 3, title: 'Programming Language', category: 'Technology', rating: 4.9, students: 2345, price: '$59', color: '#2ecc71' },
    { id: 4, title: 'Geometry Course', category: 'Math', rating: 4.5, students: 567, price: '$29', color: '#e74c3c' },
    { id: 5, title: 'Physics Fundamentals', category: 'Science', rating: 4.7, students: 987, price: '$45', color: '#9b59b6' },
    { id: 6, title: 'Creative Writing', category: 'Art', rating: 4.4, students: 654, price: '$35', color: '#1abc9c' },
  ];

  const tabs = ['All', 'Science', 'Art', 'Technology', 'Math'];

  const filteredCourses = courses.filter(course => {
    const matchesTab = tabValue === 0 || course.category === tabs[tabValue];
    const matchesSearch = course.title.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesTab && matchesSearch;
  });

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a2e' }}>
            All Courses
          </Typography>
          <Typography variant="body2" sx={{ color: '#8a8a9a' }}>
            Discover new courses to enhance your skills
          </Typography>
        </Box>
        <TextField
          placeholder="Search courses..."
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ width: 250 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: '#8a8a9a', fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Tabs
        value={tabValue}
        onChange={(e, newValue) => setTabValue(newValue)}
        sx={{
          mb: 3,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 500,
            minWidth: 'auto',
            px: 3,
          },
          '& .Mui-selected': { color: '#4a6cf7' },
          '& .MuiTabs-indicator': { backgroundColor: '#4a6cf7' },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab} />
        ))}
      </Tabs>

      <Grid container spacing={3}>
        {filteredCourses.map((course) => (
          <Grid item xs={12} sm={6} md={4} key={course.id}>
            <Card sx={{ borderRadius: 3, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', border: '1px solid #eef2f7', height: '100%' }}>
              <CardContent sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <Avatar sx={{ bgcolor: `${course.color}15`, color: course.color, width: 36, height: 36 }}>
                    <School fontSize="small" />
                  </Avatar>
                  <Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, color: '#1a1a2e' }}>
                      {course.title}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#8a8a9a' }}>
                      {course.category}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Rating value={course.rating} precision={0.1} size="small" readOnly />
                    <Typography variant="caption" sx={{ color: '#8a8a9a', ml: 0.5 }}>({course.rating})</Typography>
                  </Box>
                  <Typography variant="caption" sx={{ color: '#8a8a9a', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <People sx={{ fontSize: 14 }} /> {course.students}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#4a6cf7' }}>
                    {course.price}
                  </Typography>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      bgcolor: '#1a1a2e',
                      '&:hover': { bgcolor: '#2a2a4e' },
                      borderRadius: 2,
                      textTransform: 'none',
                      px: 3,
                    }}
                  >
                    Enroll
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AllCourses;